export default "__VITE_ASSET__BoUqXtE6__"